import SearchModalResultsLoader from './SearchModalResultsLoader';

export default SearchModalResultsLoader;
